import React from 'react';

const Loadable = React.lazy(() => import('../../pages/SupportAgent/SupportAgent'));

export default Loadable;
